export default "__VITE_ASSET__4847e8a9__"